// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountUnificationAccountControllerApplication --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountUnificationAccountControllerApplicationFragment on OpenapiAccountUnificationAccountControllerApplication {
    loss_liable
    onboarding_owner
    pricing_controls
  }
`;

export const stripeAccountUnificationAccountControllerApplicationFragment: StripeAccountUnificationAccountControllerApplicationFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountUnificationAccountControllerApplicationFragmentData = {
  readonly __typename: 'OpenapiAccountUnificationAccountControllerApplication';
  readonly loss_liable: boolean;
  readonly onboarding_owner: boolean;
  readonly pricing_controls: boolean;
};

export type StripeAccountUnificationAccountControllerApplicationFragmentVariables =
  Exact<{[key: string]: never}>;

const stripeAccountUnificationAccountControllerApplicationFragmentPermissions =
  {} as const;

doc.permissions =
  stripeAccountUnificationAccountControllerApplicationFragmentPermissions;

export type StripeAccountUnificationAccountControllerApplicationFragmentPermissions =
  V1PermissionToken<
    typeof stripeAccountUnificationAccountControllerApplicationFragmentPermissions
  >;

export type StripeAccountUnificationAccountControllerApplicationFragmentDocument =
  GraphQlDocument<
    StripeAccountUnificationAccountControllerApplicationFragmentData,
    StripeAccountUnificationAccountControllerApplicationFragmentVariables,
    StripeAccountUnificationAccountControllerApplicationFragmentPermissions
  >;
